import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { questionList, questionViews, questionHotList, questionGroupList, upVote, downVote } from "@/api/management/QAHelper";
import { _debounce } from "@/util/utils";
export default {
  name: "QAHelper",
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      messageList: [],
      inputMessage: "",
      handleInputMessage: "",
      questionList: [],
      activeTab: 0,
      hotListPage: {
        current: 1,
        size: 5,
        total: 0,
        pages: 1
      },
      hotList: [],
      questionGroupList: [],
      navQusList: [],
      navLoading1: false,
      navLoading2: false,
      drawer: false,
      drawerLoading: false,
      clickNav: {},
      suggestions: [],
      inputting: false,
      searching: false
    };
  },
  components: {},
  computed: {
    chartTime: function chartTime() {
      var now = new Date();
      var minutes = now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
      var hours = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();
      var week = "";

      switch (now.getDay()) {
        case 0:
          week = "星期天";
          break;

        case 1:
          week = "星期一";
          break;

        case 2:
          week = "星期二";
          break;

        case 3:
          week = "星期三";
          break;

        case 4:
          week = "星期四";
          break;

        case 5:
          week = "星期五";
          break;

        case 6:
          week = "星期六";
          break;
      }

      return "".concat(now.getMonth() + 1, "\u6708").concat(now.getDate(), "\u65E5 ").concat(hours, ":").concat(minutes, " ").concat(week);
    }
  },
  filters: {},
  watch: {
    inputMessage: function inputMessage() {
      this.suggestions = [];
    }
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.pushMessage("receive", "您可以输入问题关键词进行提问");
    }, 1000);
    this.initHotList();
  },
  methods: {
    chartInput: _debounce(function () {
      var _this2 = this;

      if (!this.inputMessage) {
        return;
      }

      this.inputting = true;
      questionList({
        current: 1,
        size: 3,
        keywords: this.inputMessage
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this2.suggestions = data.data.records || [];
        } else {
          _this2.$message.error(data.msg);
        }
      });
    }, 300),
    handleSuggestion: function handleSuggestion(val) {
      var str = this.inputMessage;

      if (str.includes("?")) {
        str = str.replace(/\?/g, "\\?");
      }

      if (str.includes("$")) {
        str = str.replace(/\$/g, "\\$");
      }

      if (str.includes("*")) {
        str = str.replace(/\*/g, "\\*");
      }

      if (str.includes("+")) {
        str = str.replace(/\+/g, "\\+");
      }

      if (str.includes(".")) {
        str = str.replace(/\./g, "\\.");
      }

      return val.replace(new RegExp(str, "g"), "<span style=\"color: #5A8FFD\">".concat(this.inputMessage, "</span>"));
    },
    suggestionClick: function suggestionClick(item) {
      this.inputMessage = "";
      this.handleSearchAnswer(item.title, item.id);
    },
    onBlur: function onBlur() {
      var _this3 = this;

      setTimeout(function () {
        _this3.inputting = false;
      }, 250);
    },
    sendMessgae: function sendMessgae(event) {
      var _this4 = this;

      event.preventDefault();

      if (!this.inputMessage || this.searching) {
        return;
      }

      this.inputting = false;
      this.pushMessage("send", this.inputMessage);
      var keywords = this.inputMessage;
      this.inputMessage = "";
      this.searching = true;
      this.pushMessage("receive", "搜索中...");
      this.$nextTick(function () {
        _this4.scrollBottom();
      });
      questionList({
        current: 1,
        size: 20,
        keywords: keywords
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this4.questionList = data.data.records || [];

          _this4.messageList.pop();

          if (_this4.questionList.length) {
            // let htmlStr = `<h4>您想了解什么"${keywords}"信息?</h4>`
            var htmlStr = "<h4>\u60A8\u662F\u60F3\u95EE?</h4>";

            _this4.questionList.forEach(function (item) {
              htmlStr += "<p><a qId=\"".concat(item.id, "\">").concat(item.title, "</a></p>");
            });

            _this4.pushMessage("receive", htmlStr);
          } else {
            _this4.giveHotQustion();
          }

          _this4.$nextTick(function () {
            _this4.scrollBottom();
          });
        } else {
          _this4.messageList.pop();

          _this4.pushMessage("receive", "服务异常,请稍后重试");
        }
      }).catch(function () {
        _this4.messageList.pop();

        _this4.pushMessage("receive", "服务异常,请稍后重试");
      }).finally(function () {
        _this4.searching = false;
      });
    },
    giveHotQustion: function giveHotQustion() {
      var _this5 = this;

      this.searching = true;
      this.pushMessage("receive", "搜索中...");
      this.$nextTick(function () {
        _this5.scrollBottom();
      });
      var obj = {
        current: 1,
        size: 5
      };
      questionHotList(obj).then(function (_ref3) {
        var data = _ref3.data;

        _this5.messageList.pop();

        if (data.code == 0) {
          if (data.data.records.length) {
            var htmlStr = "<h4>\u667A\u80FD\u95EE\u7B54\u52A9\u624B\u731C\u60A8\u60F3\u95EE\uFF1A</h4>";
            data.data.records.forEach(function (item) {
              htmlStr += "<p><a qId=\"".concat(item.id, "\">").concat(item.title, "</a></p>");
            });

            _this5.pushMessage("receive", htmlStr);
          } else {
            _this5.pushMessage("receive", "没有找到答案");
          }
        } else {
          _this5.pushMessage("receive", "服务异常,请稍后重试");
        }

        _this5.$nextTick(function () {
          _this5.scrollBottom();
        });
      }).catch(function () {
        _this5.messageList.pop();

        _this5.pushMessage("receive", "服务异常,请稍后重试");
      }).finally(function () {
        _this5.searching = false;
      });
    },
    pushMessage: function pushMessage(type, content, id, voteFlag) {
      this.messageList.push({
        content: content,
        type: type,
        voteFlag: voteFlag,
        id: id
      });
    },
    messageClick: function messageClick(event) {
      if (this.searching) {
        return;
      }

      if (event.target.nodeName === "A") {
        var htmlStr = event.target.innerHTML;
        var id = event.target.getAttribute("qId");
        this.handleSearchAnswer(htmlStr, id);
      }
    },
    hotQuestionClick: function hotQuestionClick(item) {
      if (this.searching) {
        return;
      }

      this.handleSearchAnswer(item.title, item.id);
    },
    handleSearchAnswer: function handleSearchAnswer(htmlStr, id) {
      var _this6 = this;

      this.pushMessage("send", htmlStr);
      this.searching = true;
      this.pushMessage("receive", "搜索中...");
      this.$nextTick(function () {
        _this6.scrollBottom();
      });
      questionViews({
        questionId: id
      }).then(function (_ref4) {
        var data = _ref4.data;

        _this6.messageList.pop();

        if (data.code == 0) {
          _this6.pushMessage("receive", data.data.content, data.data.id, true);

          _this6.$nextTick(function () {
            _this6.scrollBottom();
          });
        } else {
          _this6.messageList.pop();

          _this6.pushMessage("receive", "服务异常,请稍后重试");
        }
      }).catch(function () {
        _this6.messageList.pop();

        _this6.pushMessage("receive", "服务异常,请稍后重试");
      }).finally(function () {
        _this6.searching = false;
      });
    },
    scrollBottom: function scrollBottom() {
      var ele = document.getElementById("message-c");
      ele.scrollTop = ele.scrollHeight;
    },
    tabClick: function tabClick(index) {
      this.activeTab = index;

      if (index == 0) {
        this.initHotList();
        this.drawer = false;
      } else {
        this.getQuestionGroupList();
      }
    },
    initHotList: function initHotList() {
      this.hotListPage.current = 1;
      this.getHotList();
    },
    getHotList: function getHotList() {
      var _this7 = this;

      var obj = {
        current: this.hotListPage.current,
        size: this.hotListPage.size
      };
      this.navLoading1 = true;
      questionHotList(obj).then(function (_ref5) {
        var data = _ref5.data;

        if (data.code == 0) {
          _this7.hotList = data.data.records || [];
          _this7.hotListPage.total = data.data.total;
          _this7.hotListPage.pages = data.data.pages;
        } else {
          _this7.$message.error(data.msg);
        }
      }).finally(function () {
        setTimeout(function () {
          _this7.navLoading1 = false;
        }, 500);
      });
    },
    changeHotList: function changeHotList() {
      this.hotListPage.current += 1;

      if (this.hotListPage.current > this.hotListPage.pages) {
        this.hotListPage.current = 1;
      }

      this.getHotList();
    },
    getQuestionGroupList: function getQuestionGroupList() {
      var _this8 = this;

      this.navLoading2 = true;
      questionGroupList({
        current: 1,
        size: 100
      }).then(function (_ref6) {
        var data = _ref6.data;

        if (data.code == 0) {
          _this8.questionGroupList = data.data.records || [];
        } else {
          _this8.$message.error(data.msg);
        }
      }).finally(function () {
        setTimeout(function () {
          _this8.navLoading2 = false;
        }, 500);
      });
    },
    navClick: function navClick(item) {
      var _this9 = this;

      this.clickNav = item;
      this.drawerLoading = true;
      questionList({
        current: 1,
        size: 100,
        groupId: item.id
      }).then(function (_ref7) {
        var data = _ref7.data;

        if (data.code == 0) {
          _this9.navQusList = data.data.records || [];
        } else {
          _this9.$message.error(data.msg);
        }
      }).finally(function () {
        _this9.drawerLoading = false;
      });
      this.drawer = true;
    },
    submitVote: function submitVote(item, index, type) {
      var _this10 = this;

      this.messageList[index].voteFlag = false;
      var rq;

      if (type === "upVote") {
        rq = upVote;
      } else {
        rq = downVote;
      }

      rq({
        questionId: item.id
      }).then(function (_ref8) {
        var data = _ref8.data;

        if (data.code == 0) {
          _this10.$message.success("评价成功");
        } else {
          _this10.$message.error(data.msg);

          _this10.messageList[index].voteFlag = true;
        }
      }).catch(function () {
        _this10.messageList[index].voteFlag = true;
      });
    }
  }
};